import { Skeleton, Tooltip } from 'antd'
import { useIntl } from 'react-intl'

type RelativeTimeProps = {
  timestamp: number
  tooltipTitleHasOnlyDate?: boolean
  isLoading?: boolean
}

export enum TimeUnit {
  'second' = 'second',
  'minute' = 'minute',
  'hour' = 'hour',
  'day' = 'day',
  'week' = 'week',
  'month' = 'month',
  'quarter' = 'quarter',
  'year' = 'year',
}

export function RelativeTime({
  timestamp,
  tooltipTitleHasOnlyDate,
  isLoading = false,
}: RelativeTimeProps): JSX.Element {
  const intl = useIntl()
  if (isLoading) {
    return (
      <Skeleton
        active={true}
        loading={isLoading}
        paragraph={false}
        title={{ width: 50 }}
      />
    )
  }
  if (timestamp) {
    let time = intl.formatDate(timestamp, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    let value =
      timestamp >= 1633375032928
        ? (new Date().getTime() - timestamp) / 1000
        : timestamp
    if (value < 60 * 60 * 24 * 21) {
      let unit = TimeUnit.second
      if (value > 59.99) {
        value = value / 60
        unit = TimeUnit.minute
      }

      if (value > 59.99 && unit === TimeUnit.minute) {
        value = value / 60
        unit = TimeUnit.hour
      }

      if (value > 23.99 && unit === TimeUnit.hour) {
        value = value / 24
        unit = TimeUnit.day
      }

      if (value > 6.99 && unit === TimeUnit.day) {
        value = value / 7
        unit = TimeUnit.week
      }

      if (value > 4.99 && unit === TimeUnit.week) {
        value = value / 7
        unit = TimeUnit.month
      }
      value = Math.floor(value)

      time = intl.formatRelativeTime(-value, unit, {
        numeric: 'always',
        style: 'long',
      })
    }
    return (
      <Tooltip
        title={
          tooltipTitleHasOnlyDate
            ? intl.formatDate(timestamp)
            : `${intl.formatDate(timestamp)} ${intl.formatTime(timestamp)}`
        }
      >
        {time}
      </Tooltip>
    )
  }
  return null
}
